export const multiPlugin = (editor, opts = {}, content) => {
  const themeName = editor.config.pluginsOpts.themes.filter(
    (f) => (f.themeId = editor.config.pluginsOpts.themeId),
  )
  const labels = {
    block1: true,
  }

  const categories = {
    category1: themeName,
  }

  opts = { labels: labels, categories: categories }
  loadComponents(editor, opts, content)
}

const loadComponents = (editor) => {
  const blcks = editor.config.pluginsOpts.blocks.filter(
    (f) => f.themeId === editor.config.pluginsOpts.themeId,
  )
  blcks.map((blk, blkInd) => {
    editor.BlockManager.add('block' + blkInd, {
      label: blk.themeBlockName,
      category: blk.themeBlockCategory,
      content: `${blk.themeBlockContent}`,
    })
  })
}
